import { Dropdown } from "antd";
import { useMemo, useState } from "react";


const DropdownButton = ({ submenu, defaultValue, text, onClick }) => {
  const [value, setValue] = useState(defaultValue);

  const menuProps = useMemo(() => ({
    items: submenu.map(m => ({ label: m.label, key: m.value })),
    onClick: (evt) => setValue(evt.key),
  }), [submenu, setValue]);

  return (
    <div style={{ display: "inline-block", marginLeft: 4 }}><Dropdown.Button menu={menuProps} onClick={ () => onClick(value) } >
          { text.apply ? text.apply(null, [value]) : text }
        </Dropdown.Button></div>
  )
}

export default DropdownButton;